import React from 'react'
import { Card } from 'react-bootstrap';
import { useForm } from 'react-hook-form';
import { zodResolver } from '@hookform/resolvers/zod';
import { IndexFilter, IndexFilterSchema } from '../../../../services/properties/schema/IndexFilterSchema';
import PreferedCurrencyComponent from './PreferedCurrencyComponent';
import PropertiesTypeComponent from './PropertiesTypeComponent';
import ActiveStatusComponent from './ActiveStatusComponent';
import NeedsReviewComponent from './NeedsReviewComponent';
import GroupFilterComponent from './GroupFilterComponent';
import BillingConnectionFilterComponent from './BillingConnectionFilterComponent';
import { useAuth } from '../../../../auth/context/AuthProvider';
import Swal from 'sweetalert2';

interface FilterComponentProps {
    handleFilter: (data: IndexFilter) => void
}

const FilterComponent: React.FC<FilterComponentProps> = ({ handleFilter }) => {
    const { user } = useAuth();
    // Filter group hanya untuk role dev.
    const isDev = !!user?.role?.includes('dev');
    const { control, handleSubmit, formState: { errors }, reset } = useForm<IndexFilter>({
        resolver: zodResolver(IndexFilterSchema),
    });

    const handleFilterChange = (data: IndexFilter) => {
        Swal.fire({
            title: 'Filter Applied',
            text: 'Filter has been applied',
            icon: 'success',
            timer: 1500,
            showConfirmButton: false
        });
        handleFilter(data);
    }
    const handleFilterReset = () => {
        reset();
        Swal.fire({
            title: 'Filter Reset',
            text: 'Filter has been reset',
            icon: 'success',
            timer: 1500,
            showConfirmButton: false
        });
        handleFilter({});
    }

    return (
        <Card className="mb-3 shadow-none">
            <Card.Body>
                <form onSubmit={handleSubmit(handleFilterChange)}>
                    <div className='d-flex gap-3'>
                        <PreferedCurrencyComponent control={control} errors={errors} />
                        <PropertiesTypeComponent control={control} errors={errors} />
                        <ActiveStatusComponent control={control} errors={errors} />
                        <NeedsReviewComponent control={control} errors={errors} />
                        {isDev && <GroupFilterComponent control={control} errors={errors} />}
                        {isDev && <BillingConnectionFilterComponent control={control} errors={errors} />}
                    </div>
                    <div className="d-flex flex-column flex-md-row align-items-md-center justify-content-md-between mt-3">
                        {/* Reset filter small button */}
                        <div className="col-md-3 mt-2 mt-md-0">
                            <button
                                type='button'
                                className="btn btn-secondary btn-sm"
                                onClick={() => handleFilterReset()}
                            >
                                Reset Filter
                            </button>
                            <button
                                type='submit'
                                className="btn btn-primary btn-sm ms-2"
                                onClick={handleSubmit(handleFilterChange)}
                            >
                                Apply Filter
                            </button>
                        </div>
                    </div>
                </form>
            </Card.Body>
        </Card>
    )
}

export default FilterComponent